<template>
    <AtendimentoManage
        :uuidFrom="$route.params.uuid != undefined ? $route.params.uuid : ''"
        :reloadData="reloadData"
        @saved="redirectToPage"
        @voltar="$router.push({ name: 'ven-atendimento-list' })"
        @isChanged="isChanged = $event"
    />
</template>

<script>
import AtendimentoManage from '@/components/vendas/atendimento/AtendimentoManage.vue';

export default {
    name: 'AtendimentoManageRoute',

    beforeRouteLeave(to, from, next) {
        if (from.name == 'ven-atendimento-new' && to.name == 'ven-atendimento-edit') {
            this.reloadData = true;
            setTimeout(() => (this.reloadData = false), 500);
        }

        // if (this.isChanged && !'ven-atendimento'.includes(to.name)) {
        if (this.isChanged && to.name != 'ven-atendimento-list') {
            this.$root.confirm({
                message: this.$t('msg-tem-certeza-alteracoes'),
                onConfirm: (_) => {
                    next();
                },
                onCancel: (_) => {
                    next(false);
                },
            });
        } else {
            next();
        }
    },

    components: {
        AtendimentoManage,
    },
    data() {
        return {
            reloadData: false,
            isChanged: false,
        };
    },
    methods: {
        redirectToPage(uuid) {
            setTimeout(
                () =>
                    this.$router.push({
                        name: 'ven-atendimento-edit',
                        params: { uuid: uuid },
                    }),
                1000
            );
        },
    },
};
</script>
